// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__wswxs","label":"Section_label__1zvE7","contentWrap":"Section_contentWrap__EDiqO","footer":"Section_footer__a7JVU","footerInner":"Section_footerInner__3BxwU"};